export const STATUS_CHOICES = {
  DRAFT: 'DRAFT',
  RUNNING: 'RUNNING',
  DONE: 'DONE',
  ERROR: 'ERROR'
}

export const VESSEL_LOAD_CASE_FIELDS = {
  MAIN_ENGINE_APPLIED_POWER: {
    INDIVIDUAL_VALUE: 'main_engine_applied_power',
    RANGE_VALUES: [
      'main_engine_applied_power_lower_limit',
      'main_engine_applied_power_upper_limit',
      'main_engine_applied_power_step_size'
    ],
    RANGE_INDICATOR: 'main_engine_applied_power_range'
  },
  TRANSVERSE_THRUSTER_APPLIED_POWER: {
    INDIVIDUAL_VALUE: 'transverse_thruster_applied_power',
    RANGE_VALUES: [
      'transverse_thruster_applied_power_lower_limit',
      'transverse_thruster_applied_power_upper_limit',
      'transverse_thruster_applied_power_step_size'
    ],
    RANGE_INDICATOR: 'transverse_thruster_applied_power_range'
  },
  DRAUGHT: {
    INDIVIDUAL_VALUE: 'draught',
    RANGE_VALUES: ['draught_lower_limit', 'draught_upper_limit', 'draught_step_size'],
    RANGE_INDICATOR: 'draught_range'
  },
  SHIP_SIDE_DISTANCE_SIDE: {
    INDIVIDUAL_VALUE: 'ship_side_distance_side',
    RANGE_VALUES: [
      'ship_side_distance_side_lower_limit',
      'ship_side_distance_side_upper_limit',
      'ship_side_distance_side_step_size'
    ],
    RANGE_INDICATOR: 'ship_side_distance_side_range'
  },
  SHIP_SIDE_DISTANCE_AFT: {
    INDIVIDUAL_VALUE: 'ship_side_distance_aft',
    RANGE_VALUES: [
      'ship_side_distance_aft_lower_limit',
      'ship_side_distance_aft_upper_limit',
      'ship_side_distance_aft_step_size'
    ],
    RANGE_INDICATOR: 'ship_side_distance_aft_range'
  },
  ANGLE_FLOW_ATTACK: {
    INDIVIDUAL_VALUE: 'angle_flow_attack',
    RANGE_VALUES: [
      'angle_flow_attack_lower_limit',
      'angle_flow_attack_upper_limit',
      'angle_flow_attack_step_size'
    ],
    RANGE_INDICATOR: 'angle_flow_attack_range'
  },
  MAIN_ENGINE_NUMBER: {
    INDIVIDUAL_VALUE: 'main_engine_number',
    RANGE_VALUES: [
      'main_engine_number_lower_limit',
      'main_engine_number_upper_limit',
      'main_engine_number_step_size'
    ],
    RANGE_INDICATOR: 'main_engine_number_range'
  },
  TRANSVERSE_THRUSTER_NUMBER: {
    INDIVIDUAL_VALUE: 'transverse_thruster_number',
    RANGE_VALUES: [
      'transverse_thruster_number_lower_limit',
      'transverse_thruster_number_upper_limit',
      'transverse_thruster_number_step_size'
    ],
    RANGE_INDICATOR: 'transverse_thruster_number_range'
  }
}

export const ENVIRONMENT_LOAD_CASE_FIELDS = {
  EXPECTED_SCOUR_DEPTH: {
    INDIVIDUAL_VALUE: 'expected_scour_depth',
    RANGE_VALUES: [
      'expected_scour_depth_lower_limit',
      'expected_scour_depth_upper_limit',
      'expected_scour_depth_step_size'
    ],
    RANGE_INDICATOR: 'expected_scour_depth_range'
  },
  EXPECTED_SCOUR_SLOPE: {
    INDIVIDUAL_VALUE: 'expected_scour_slope',
    RANGE_VALUES: [
      'expected_scour_slope_lower_limit',
      'expected_scour_slope_upper_limit',
      'expected_scour_slope_step_size'
    ],
    RANGE_INDICATOR: 'expected_scour_slope_range'
  },
  BED_LEVEL: {
    INDIVIDUAL_VALUE: 'bed_level',
    RANGE_VALUES: ['bed_level_lower_limit', 'bed_level_upper_limit', 'bed_level_step_size'],
    RANGE_INDICATOR: 'bed_level_range'
  },
  BED_GRADIENT: {
    INDIVIDUAL_VALUE: 'bed_gradient',
    RANGE_VALUES: [
      'bed_gradient_lower_limit',
      'bed_gradient_upper_limit',
      'bed_gradient_step_size'
    ],
    RANGE_INDICATOR: 'bed_gradient_range'
  },
  SLOPE_GRADIENT: {
    INDIVIDUAL_VALUE: 'slope_gradient',
    RANGE_VALUES: [
      'slope_gradient_lower_limit',
      'slope_gradient_upper_limit',
      'slope_gradient_step_size'
    ],
    RANGE_INDICATOR: 'slope_gradient_range'
  },
  QUAY_WALL_EMBEDMENT_LEVEL: {
    INDIVIDUAL_VALUE: 'quay_wall_embedment_level',
    RANGE_VALUES: [
      'quay_wall_embedment_level_lower_limit',
      'quay_wall_embedment_level_upper_limit',
      'quay_wall_embedment_level_step_size'
    ],
    RANGE_INDICATOR: 'quay_wall_embedment_level_range'
  },
  FACTOR_CONFINEMENT: {
    INDIVIDUAL_VALUE: 'factor_confinement',
    RANGE_VALUES: [
      'factor_confinement_lower_limit',
      'factor_confinement_upper_limit',
      'factor_confinement_step_size'
    ],
    RANGE_INDICATOR: 'factor_confinement_range'
  }
}
